import React from "react";
import classNames from "classnames";
import * as c from "./landingPages.module.scss";
import Layout from "@components/layout";
import WistiaVideoEmbed from "@components/wistia/wistiaVideoEmbed";
import { DMFullBleedPageHeader } from "@components/pages/landingPages/dMFullBleedPageHeader";
import { DMSideBySidePageHeader } from "@components/pages/landingPages/dMSideBySidePageHeader";
import { getLandingPageSections } from "@templates/landingPages/landingPageSections";

const DirectMailPage = ({ contentfulLandingPage }) => {
  const { pageHeader, actionSections, sections, embeddedWistiaVideoId, embeddedWistiaVideoTitle } =
    contentfulLandingPage;
  const { sectionComponents, actionSectionsComponents } = getLandingPageSections({
    sections,
    actionSections,
    className: c,
  });
  return (
    <Layout
      navColorVariant={pageHeader?.darkBackground ? "cream-100" : pageHeader.backgroundColor?.value || "default"}
      className={classNames(c.pageWrapper, "cream-100")}
    >
      {pageHeader?.backgroundImage ? (
        <DMFullBleedPageHeader pageHeaderData={pageHeader} />
      ) : (
        <DMSideBySidePageHeader pageHeaderData={pageHeader} />
      )}

      <div className={c.sections}>
        {embeddedWistiaVideoId && (
          <section className={c.wistiaEmbed}>
            <h4 className="h4">{embeddedWistiaVideoTitle}</h4>
            <WistiaVideoEmbed
              wistiaOptions={"seo=false controlsVisibleOnLoad=false"}
              wistiaVideoId={embeddedWistiaVideoId}
            />
          </section>
        )}

        {sectionComponents}

        {actionSectionsComponents}
      </div>
    </Layout>
  );
};

export default DirectMailPage;
